<script lang="ts" setup>
import type { EpcGes } from '@@/shared/property/epc-ges';

defineProps<{
  epcGes: EpcGes
}>();

const { amount } = useIadFormat();
</script>

<template>
  <div class="grid grid-rows">
    <p v-text="$t(`property.epc_ges.amount.title`)" />
    <p
      v-if="epcGes.date"
      class="text-sm"
      v-text="$t(`property.epc_ges.year_description`, { year: new Date(epcGes.date).getFullYear() })"
    />
    <div class="text-sm font-semibold">
      <p
        v-if="epcGes.amount.min"
        v-text="$t(`property.epc_ges.amount.min`, { amount: amount(epcGes.amount.min) })"
      />
      <p
        v-if="epcGes.amount.max"
        v-text="$t(`property.epc_ges.amount.max`, { amount: amount(epcGes.amount.max) })"
      />
      <p
        v-if="epcGes.amount.fix"
        v-text="$t(`property.epc_ges.amount.fix`, { amount: amount(epcGes.amount.fix) })"
      />
    </div>
  </div>
</template>
